import React, { PropsWithChildren } from 'react';
import { useOrder } from 'hooks/useOrder';
import { CartProvider } from './cartContext';

const Cart: React.FC<PropsWithChildren> = (props) => {
  const providerValue = useOrder();

  return <CartProvider value={providerValue} {...props} />;
};

export default Cart;
